



























import Vue from "vue";

import AdBanner from "@/parts/util/AdBanner.vue";

interface Menu {
  title: string;
  list: MenuItem[];
}

interface MenuItem {
  to: string;
  name: string;
  /**
   * NOTE: 外部リンクの場合は anchor を指定してください
   *       デフォルトは router-link です
   */
  elementType?: "anchor" | "router-link";
  /** NOTE: 特殊なURLの判定をする為に正規表現を追加 */
  regex?: RegExp;
}

export default Vue.extend({
  name: "SideBar",
  components: {
    AdBanner,
  },
  props: {
    menuName: String,
  },
  data() {
    let menu: Menu[];
    if (this.menuName == "guide") {
      menu = [
        {
          title: "概要",
          list: [
            { to: "/guide/corporate", name: "基本情報" },
            { to: "/guide/corporate/register", name: "会員に関する情報" },
          ],
        },
        {
          title: "参加プロジェクト",
          list: [
            { to: "/guide/corporate/project/list", name: "プロジェクトの依頼一覧" },
            { to: "/guide/corporate/project/add", name: "プロジェクトの追加" },
            { to: "/guide/corporate/project/edit", name: "プロジェクトの編集" },
            { to: "/guide/corporate/project/delete", name: "プロジェクトの削除" },
          ],
        },
        {
          title: "作成した依頼",
          list: [
            { to: "/guide/corporate/deal/list", name: "作成した依頼一覧" },
            { to: "/guide/corporate/deal/create", name: "依頼を作成、更新、削除する" },
          ],
        },
        {
          title: "メンバー管理",
          list: [
            { to: "/guide/corporate/member/list", name: "メンバーの一覧" },
            { to: "/guide/corporate/member/create", name: "メンバーを追加" },
          ],
        },
        {
          title: "各種設定",
          list: [
            { to: "/guide/corporate/settings/account", name: "アカウント情報" },
            { to: "/guide/corporate/settings/notification", name: "通知設定" },
            { to: "/guide/corporate/settings/info", name: "法人情報" },
            { to: "/guide/corporate/settings/billing", name: "請求明細" },
          ],
        },
      ];
    } else {
      menu = [
        {
          title: "ABOUT",
          list: [
            // NOTE: GUIDを判定する為の正規表現
            { to: "/announcements", name: "お知らせ", regex: new RegExp(/^\/announcements\/([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})$/) },
            { to: "/question", name: "よくある質問" },
            { to: "/contact", name: "お問い合わせ" },
            { to: "https://idh-net.co.jp/about/", name: "運営会社", elementType: "anchor" },
          ],
        },
        {
          title: "TERMS",
          list: [
            { to: "/terms", name: "利用規約" },
            { to: "/privacy", name: "個人情報の取り扱いについて" },
            { to: "/law", name: "特定商取引法に基づく表記" },
          ],
        },
      ];
    }
    return {
      menu,
    };
  },
  methods: {
    current(item: MenuItem, path: string) {
      let current = false; 
      if (item.regex) {
        current = item.regex.test(path);
      }
      if (!current) {
        current = item.to == path;
      }
      return current;
    }
  },
});
